import { ActivitePrestation } from "./activitePrestation";
import { Beneficiaire } from "./beneficiaire";
import { BonCommande } from "./bonCommande";
import { CanalCommunication } from "./canalCommunication";
import { Employee } from "./employee/employee";
import { ObjectifPro } from "./objectifPro";
import { OrigineDemande } from "./origineDemande";
import { Prescripteur } from "./prescripteur";
import { PrescripteurContact } from "./prescripteurContact";
import { Service } from "./service";
import { Situation } from "./situation";
import { TypeFormation } from "./typeFormation";
import { TypeHandicap } from "./typeHandicap";

export class Prestation {
    id: number;
    typePrestation: string;
    statut: string;
    natureAbandon: string;
    commentaireAbandon: string;
    etatQualification: string;
    motifRefus: string;
    reorientation: boolean;
    organismeReorientation: string;
    contactReorientation: string;
    beneficiaire: Beneficiaire;
    dateDebut: string;
    dateFin: string;
    dateDepot: string;
    dateValidation: string;
    dateLimite: string;
    intervenants: Employee[];
    intervenant: Employee;
    intervenantModule: Employee;
    bonCommande: BonCommande;
    dateAffectBdc: string;
    raison: string;
    imperatifs: string;
    situation: Situation;
    origineDemande: OrigineDemande;
    canalCommunication: CanalCommunication;
    prescripteur: Prescripteur;
    prescripteurContact: PrescripteurContact;
    raisonDemandeAccomp: string;
    objectifPro: ObjectifPro;
    metiersCibles: string;
    typeAccompagnement: string;
    difficultes: string;
    besoins: string;
    origineHandicap: string;
    rapportHandicap: string;
    logement: string;
    sante: string;
    situationFinanciere: string;
    situationFamiliale: string;
    smBilan: string;
    smAccomp: string;
    deMetiersCibles: string;
    deContraintesHandicap: string;
    deDispositifs: string;
    deProjetPro: string;
    deRuptureParcours: string;
    deBesoinsIdent: string;
    eeLimites: string;
    eeQuestEmploi: string;
    eeBesoinsAdapt: string;
    eePbAccess: string;
    eeAccompDejaMene: string;
    eeNomEntreprise: string;
    eeNomContactEntreprise: string;
    eePrenomContactEntreprise: string;
    eeMailContactEntreprise: string;
    eeTelContactEntreprise: string;
    eeSyntheseSitEmployeur: string;
    eeHoraires: string;
    eeFichePoste: string;
    efLimiteCapacite: string;
    efQuestionnement: string;
    efAccompDejaMene: string;
    efAccessibilite: string;
    efTypeFormation: TypeFormation;
    efBesoinsAt: string;
    efNomCentreFormation: string;
    efPlanning: string;
    efRemarqueRef: string;
    syntheseInfo: string;
    premieresOrientations: string;
    // orientationMdph: string;
    // freins: string;
    // ressources: string;
    // contraintes: string;
    // propositionsActions: string;
    // planActionPerso: string;
    analyseAdequation: string;
    recommandantions: string
    periode: number;
    duree: number;
    dureePrevisionnelle: number;
    oldDuree: number;
    idQualification: number;
    statutBeneficiaire: string;
    dateAr: string;
    nombreDemande: number;
    demandePrescripteur: string;
    reponseDemande: string;
    typologieDemande: string;
    situationGeographique: string;
    typeHandicap: TypeHandicap;
    modules: string[];
    typeHandicaps: TypeHandicap[];
    service: Service;
    serviceChefFile: Service;
    argumentaire: string;
    numeroCommande: string;
    langage: string;
    praxie: string;
    memoire: string;
    fonctExecutif: string;
    fonctAttent: string;
    cognitionSociale: string;
    comportement: string;
    preconisations: string;
    observations: string;

    ressourcesFinancieres: string;  
    niveauRendement: string;    
    satisfaction: string;   
    stress: string; 
    forces: string; 
    attention: string;
    gnosies: string;
    pointVigilence: string;
    ppIntitulePoste: string;
    ppDescriptionPosteBenef: string;
    ppDescriptionPosteOf: string;
    ppEntrepriseVise: string;

    // datePrescription: string;
    // datePremierContact: string;
    // datePremierRv: string;
    // dateS3: string;
    // dateS6: string;
    // preconisationsProposes: string;
    // comprehensionPreco: boolean;
    // description: string;
    // complements: string;
    // nomS3: string;
    // prenomS3: string;
    // fonctionS3: string;
    // preconisationMeoS3: boolean;
    // descriptionS3: string;
    // freinS3: string;
    // reponseS3: string;
    // nomS6: string;
    // prenomS6: string;
    // fonctionS6: string;
    // preconisationMeoS6: boolean;
    // descriptionS6: string;
    // freinS6: string;
    // reponseS6: string;

    
    dateContactPrescripteur: string;
    dateContactPersonne: string;
    dateContactEmployeur: string;
    meoSolutions: string;
    precoNonMeo: string;
    raisons: string;
    propositionAs: boolean;
    propositionAutre: boolean;
    propositionAutreDetails: string;
    heuresDeclarees: number;

    dateDebutContrat: string;
    dateFinContrat: string;
    salarieEntreprise: boolean;
    accordEmployeur: boolean;
    arretTravail: boolean;
    agentFonctPub: boolean;
    accordHandicap: boolean;

    prescripionOrientee: boolean;
    datePrescriptionOrientee: string;
    activites: ActivitePrestation[];
    sychroIsyplanning: boolean;
    notifRestitution3moisSent: boolean;
    notifRestitution6moisSent: boolean;
    notifRestitution9moisSent: boolean;
    notifRestitution12moisSent: boolean;
    notifRestitution15moisSent: boolean;
    notifRestitution18moisSent: boolean;

    constructor(
        options: {
            statut?: string;
            beneficiaire?: Beneficiaire;
            dateDebut?: string;
            dateFin?: string;
            dateLimite?: string;
            typePrestation?: string;
            intervenants?: Employee[];
            raison?: string;
            commentaireAbandon?: string;
            imperatifs?: string;
            situation?: Situation;
            origineDemande?: OrigineDemande;
            canalCommunication?: CanalCommunication;
            prescripteur?: Prescripteur;
            raisonDemandeAccomp?: string;
            objectifPro?: ObjectifPro;
            competenceProPerso?: string;
            besoinsFormation?: string;
            metiersCibles?: string;
            secteursRecherches?: string;
            preferencesGeo?: string;
            contraintesHandicap?: string;
            syntheseInfo?: string;
            premieresOrientations?: string;
            orientationMdph?: string;
            freins?: string;
            ressources?: string;
            contraintes?: string;
            propositionsActions?: string;
            planActionPerso?: string;
            analyseAdequation?: string;
            recommandantions?: string;
            periode?: number;
            duree?: number;
            idQualification?: number;
            modules?: string[];
            typeHandicaps?: TypeHandicap[];
            activites?: ActivitePrestation[];
        } = {}
    ) {
        this.statut = options.statut || null;
        this.beneficiaire = options.beneficiaire || null;
        this.dateDebut = options.dateDebut || null;
        this.dateFin = options.dateFin || null;
        this.typePrestation = options.typePrestation || null;
        this.dateLimite = options.dateLimite || null;
        this.intervenants = options.intervenants || [];
        this.raison = options.raison || null;
        this.commentaireAbandon = options.commentaireAbandon || null;
        this.imperatifs = options.imperatifs || null;
        this.situation = options.situation || null;
        this.origineDemande = options.origineDemande || null;
        this.prescripteur = options.prescripteur || null;
        this.raisonDemandeAccomp = options.raisonDemandeAccomp || null;
        this.metiersCibles = options.metiersCibles || null;
        this.syntheseInfo = options.syntheseInfo || null;
        this.premieresOrientations = options.premieresOrientations || null;
        // this.orientationMdph = options.orientationMdph || null;
        // this.freins = options.freins || null;
        // this.ressources = options.ressources || null;
        // this.contraintes = options.contraintes || null;
        // this.propositionsActions = options.propositionsActions || null;
        // this.planActionPerso = options.planActionPerso || null;
        this.analyseAdequation = options.analyseAdequation || null;
        this.recommandantions = options.recommandantions || null;
        this.periode = options.periode || null;
        this.duree = options.duree || null;
        this.idQualification = options.idQualification || null;
        this.modules = options.modules || [];
        this.typeHandicaps = options.typeHandicaps || [];
        this.activites = options.activites || [];
    }
}

export enum MotifRefusString {
    I = "Sensibilisation générale au handicap",
    II = 'Canal de communication sur les appuis spécifiques',
    III = "Demande de renseignement dans le cadre d'un suivi de dossier",
    IV = 'Quelques techniques relatives à la plateforme digitale',
}

export enum MotifRefus {
    'I' = "I",
    'II' = 'II',
    'III' = 'III',
    'IV' = 'IV',
}

export enum NatureAbandonString {
    NATABANDON1 = 'Modification majeure du besoin initial',
    NATABANDON2 = 'Abandon de la personne',
    NATABANDON3 = 'Conditions de mise en œuvre non réunies',
    NATABANDON4 = 'Absence accord employeur/centre de formation',
    NATABANDON5 = 'Refus et réorientation le cas échéant',
    NATABANDON6 = 'Erreur de saisie sur la demande',
    NATABANDON7 = 'Restitution intermédiaire non validée',
    NATABANDON8 = 'Demande terminée avec suivi des préconisations',
    NATABANDON9 = 'Demande terminée sans suivi des préconisations',
    NATABANDON10 = 'Demande échue et prolongée',
    NATABANDON11 = 'Qualification validée',
}

export enum NatureAbandon {
    'NATABANDON1' = 'NATABANDON1',
    'NATABANDON2' = 'NATABANDON2',
    'NATABANDON3' = 'NATABANDON3',
    'NATABANDON4' = 'NATABANDON4',
    'NATABANDON5' = 'NATABANDON5',
    'NATABANDON6' = 'NATABANDON6',
    'NATABANDON7' = 'NATABANDON7',
    'NATABANDON8' = 'NATABANDON8',
    'NATABANDON9' = 'NATABANDON9',
    'NATABANDON10' = 'NATABANDON10',
    'NATABANDON11' = 'NATABANDON11',
}

export enum NatureAbandonAnnulation {
    'NATABANDON1' = 'NATABANDON1',
    'NATABANDON2' = 'NATABANDON2',
    'NATABANDON3' = 'NATABANDON3',
    'NATABANDON4' = 'NATABANDON4',
    'NATABANDON5' = 'NATABANDON5',
    'NATABANDON6' = 'NATABANDON6',
    'NATABANDON7' = 'NATABANDON7',
}

export enum DemandeAdministrativeString {
    SG = "Situation géographique",
    SB = 'Situation bénéficiaire',
}

export enum DemandeAdministrative {
    'SG' = "SG",
    'SB' = 'SB',
}

export enum TypologieDemandeString {
    HI = "Hors INFOSAS",
    OS = 'Offre de service en général',
    DA = 'Demande administrative',
    BO = 'Bonne orientation',
    DSB = 'Demande en focntion de la situation du bénéficiaire',
}

export enum TypologieDemande {
    'HI' = "HI",
    'OS' = 'OS',
    'DA' = 'DA',
    'BO' = 'BO',
    'DSB' = 'DSB',
}

export enum StatutBeneficiaireString {
    EEPUB = 'En emploi public',
    EEPRIV = 'En emploi privé',
    EF = "Vers l'emploi",
}

export enum StatutBeneficiaire {
    'EEPUB' = 'EEPUB',
    'EEPRIV' = 'EEPRIV',
    'EF' = 'EF',
}

export enum PrestationTypeString {
    QD = 'QUALIFICATION DE LA DEMANDE',
    AS = 'ANALYSE DE LA SITUATION',
    AC = 'ANALYSE DES CAPACITES',
    EAP = 'EVALUATION APPROFONDIE AVEC PRECONISATIONS',
    CAMEO = 'CONSEIL ET APPUI A LA MISE EN OEUVRE',
    SP = 'SUIVI DES PRECONISATIONS'
}

export enum PrestationTypeWithoutSpString {
    QD = 'QUALIFICATION DE LA DEMANDE',
    AS = 'ANALYSE DE LA SITUATION',
    AC = 'ANALYSE DES CAPACITES',
    EAP = 'EVALUATION APPROFONDIE AVEC PRECONISATIONS',
    CAMEO = 'CONSEIL ET APPUI A LA MISE EN OEUVRE',
}

export enum PrestationStatutString {
    OUVERT = 'Ouvert',
    COURS = 'En cours',
    ANNULE = 'Annulé',
    CLOT = 'Clôturé',
}

export enum PrestationTrackHourColor {
    CONSOMME = '#7ca8d0',
    RESTANT = '#00b456',
}

export enum PrestationStatutColor {
    OUVERT = '#7ca8d0',
    COURS = '#ffc400',
    ANNULE = '#e74848',
    CLOT = '#00b456',
}

export enum PrestationStatut {
    'OUVERT'='OUVERT',
    'COURS' = 'COURS',
    'ANNULE' = 'ANNULE',
    'CLOT' = 'CLOT',
}

export enum QualificationEtatString {
    BROUILLON = 'Brouillon',
    ENCOURS = 'En cours',
    PRISENCHARGE = 'Pris en charge',
    REFUSE = 'Refusé',
}

export enum QualificationEtat {
    'BROUILLON' = 'BROUILLON',
    'ENCOURS' = 'ENCOURS',
    'PRISENCHARGE' = 'PRISENCHARGE',
    'REFUSE' = 'REFUSE',
}

export enum DureeExecutionByType {
    'QD' = 5,
    'AS' = 20,
    'AC' = 8,
    'EAP' = 200,
    'CAMEO' = 200,
    'SP' = 5
}

export enum PeriodeExecutionByType {
    'QD' = 1,
    'AS' = 3,
    'AC' = 2,
    'EAP' = 18,
    'CAMEO' = 18,
    'SP' = 6
}

export enum PrestationType {
    'QD' = 'QD',
    'AS' = 'AS',
    'AC' = 'AC',
    'EAP' = 'EAP',
    'CAMEO' = 'CAMEO',
    'SP' = 'SP'
}

export enum ModuleType {
    'AS' = 'AS',
    'AC' = 'AC',
    'EAP' = 'EAP',
    'CAMEO' = 'CAMEO',
    'SP' = 'SP'
}

export enum ModuleTypeWithoutSP {
    'AS' = 'AS',
    'AC' = 'AC',
    'EAP' = 'EAP',
    'CAMEO' = 'CAMEO',
}